import { GuideModelStateType } from './guide';

export const GUIDE_SYS_OPINION = 'opinion';
export const GUIDE_TYPE_OPINION_OVERVIEW = 'opinion-overview';
export const GUIDE_TYPE_OPINION_FEEDS = 'opinion-feeds';
export const GUIDE_TYPE_OPINION_GAME_STORE = 'opinion-game-store';
export const GUIDE_TYPE_OPINION_COMMUNITY = 'opinion-community';
export const GUIDE_TYPE_OPINION_COMPETITOR = 'opinion-competitor';
export const GUIDE_TYPE_OPINION_DATA_SOURCE = 'opinion-data-source';

export const reducers = {
  showOpinionGuideModule(state: GuideModelStateType, action: any) {
    // console.log('showOpinionGuideModule');
    return {
      ...state,
      guideSys: action.payload ? GUIDE_SYS_OPINION : '',
      ...{
        guideType: '',
      },
    };
  },
  showOpinionGuideOverview(state: GuideModelStateType) {
    // console.log('showOpinionGuideOverview');
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_OPINION_OVERVIEW,
      },
    };
  },
  showOpinionGuideFeeds(state: GuideModelStateType) {
    // console.log('showOpinionGuideFeeds');
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_OPINION_FEEDS,
      },
    };
  },
  showOpinionGuideGameStore(state: GuideModelStateType) {
    // console.log('showOpinionGuideGameStore');
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_OPINION_GAME_STORE,
      },
    };
  },
  showOpinionGuideCommunity(state: GuideModelStateType) {
    // console.log('showOpinionGuideCommunity');
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_OPINION_COMMUNITY,
      },
    };
  },
  showOpinionGuideCompetitor(state: GuideModelStateType) {
    // console.log('showOpinionGuideCompetitor');
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_OPINION_COMPETITOR,
      },
    };
  },
  showOpinionGuideDataSource(state: GuideModelStateType) {
    // console.log('showOpinionGuideDataSource');
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_OPINION_DATA_SOURCE,
      },
    };
  },
};
